import { useState, useEffect } from "react";
import api from "../../services/api";

const COLORS = {
  primary:"#0D47A1",
  danger:"#D32F2F",
  profit:"#16A34A",
  bg:"#FFF6EA",
  card:"#FFFFFF",
  border:"#E0E0E0",
  muted:"#757575"
};

const Reports = () => {

const [type,setType]=useState("");
const [data,setData]=useState([]);

const [partyType,setPartyType]=useState("");
const [partyId,setPartyId]=useState("");

const [allParties,setAllParties]=useState([]);
const [parties,setParties]=useState([]);

const [fromDate,setFromDate]=useState("");
const [toDate,setToDate]=useState("");

/* ✅ UPDATED HEADERS */
const headersMap = {
  name: "Product",
  stock_qty: "Stock Qty",
  purchase_price: "Purchase Price (₹)",
  stock_value: "Stock Value (₹)"
};

/* LOAD ALL PARTIES */
useEffect(()=>{
const loadParties = async ()=>{
try{
const res = await api.get(`/parties/list.php`);
setAllParties(res.data?.data || []);
}catch(err){
console.log(err);
}
};
loadParties();
},[]);

/* FILTER PARTIES */
useEffect(()=>{
if(!partyType){
setParties([]);
return;
}
const filtered = allParties.filter(p => p.type === partyType);
setParties(filtered);
},[partyType,allParties]);

/* LOAD REPORT */
const load = async (t)=>{
setType(t);
setData([]);

let url = `/reports/${t}.php?`;

if(fromDate) url += `from_date=${fromDate}&`;
if(toDate) url += `to_date=${toDate}`;

const res = await api.get(url);
const d = res.data?.data || {};

if(t === "outstanding"){
const merged = [
...(d.customers || []).map(x=>({...x,type:"Customer"})),
...(d.suppliers || []).map(x=>({...x,type:"Supplier"}))
];
setData(merged);
}else{
setData(d || []);
}
};

/* ITEM BY PARTY */
const loadItemByParty = async ()=>{
let url = `/reports/item-by-party.php?type=${partyType}`;

if(partyId){
url += `&party_id=${partyId}`;
}

if(fromDate) url += `&from_date=${fromDate}`;
if(toDate) url += `&to_date=${toDate}`;

const res = await api.get(url);
setData(res.data?.data || []);
};

/* EXPORT */
const handleExport = () => {
if (!type) return;

let url = `https://codesaarthi.online/khatasaarthi/api/reports/export.php?type=${type}`;

if (fromDate) url += `&from_date=${fromDate}`;
if (toDate) url += `&to_date=${toDate}`;

if (type === "item-by-party") {
url += `&party_type=${partyType}`;
if (partyId) url += `&party_id=${partyId}`;
}

window.open(url, "_blank");
};

return(

<div style={styles.page}>

<div style={styles.header}>
<h2 style={styles.title}>Reports</h2>
<div style={styles.subtitle}>
Business summaries and analytics
</div>
</div>

{/* DATE FILTER CARD */}
<div style={styles.filterCard}>
<div style={styles.filterHeader}>Date Filter</div>

<div style={styles.filterRow}>

<div style={styles.field}>
<label style={styles.label}>From</label>
<input type="date" value={fromDate}
onChange={(e)=>setFromDate(e.target.value)}
style={styles.input}/>
</div>

<div style={styles.field}>
<label style={styles.label}>To</label>
<input type="date" value={toDate}
onChange={(e)=>setToDate(e.target.value)}
style={styles.input}/>
</div>

<div style={styles.actions}>
<button style={styles.applyBtn}
onClick={()=> type && load(type)}>
Apply
</button>

<button style={styles.clearBtn}
onClick={()=>{
setFromDate("");
setToDate("");
if(type) load(type);
}}>
Clear
</button>
</div>

</div>
</div>

<div style={styles.topControls}>

<button style={styles.exportBtn}
onClick={handleExport}
disabled={!type}>
Export Excel
</button>

<div style={styles.btnRow}>
<button style={styles.btn} onClick={()=>load("stock")}>Stock</button>
<button style={styles.btn} onClick={()=>load("low-stock")}>Low Stock</button>
<button style={styles.btn} onClick={()=>load("outstanding")}>Outstanding</button>
<button style={styles.btn} onClick={()=>load("item-details")}>Item Details</button>
<button style={styles.btn} onClick={()=>load("item-by-party")}>Item by Party</button>
<button style={styles.btn} onClick={()=>load("cash-flow")}>Cash Flow</button>
</div>

</div>

{/* TABLE */}
{data.length>0 &&(

<div style={styles.card}>
<div style={styles.tableWrap}>

<table style={styles.table}>

<thead>
<tr>
<th style={styles.th}>S.NO</th>

{Object.keys(data[0])
  .filter(h => h !== "id" && h !== "party_id" && h !== "product_id")
  .map((h)=>(
    <th key={h} style={styles.th}>
      {headersMap[h] || h}
    </th>
))}
</tr>
</thead>

<tbody>
{data.map((r,i)=>(
<tr key={i}>
<td style={styles.td}>{i + 1}</td>

{Object.entries(r)
  .filter(([key]) => key !== "id" && key !== "party_id" && key !== "product_id")
  .map(([key, value])=>{

    /* ✅ ₹ FORMAT */
    if(key === "stock_value" || key === "purchase_price"){
      value = `₹ ${Number(value).toLocaleString()}`;
    }

    return (
      <td key={key} style={styles.td}>{value}</td>
    );
})}

</tr>
))}
</tbody>

</table>

</div>
</div>

)}

</div>
);
};



const styles={

page:{
background:COLORS.bg,
padding:"20px clamp(15px,4vw,30px)",
minHeight:"100vh"
},

header:{ marginBottom:20 },

title:{ fontSize:26, fontWeight:700 },

subtitle:{ color:COLORS.muted },

filterCard:{
background:"#fff",
border:`1px solid ${COLORS.border}`,
borderRadius:12,
padding:16,
marginBottom:20,
boxShadow:"0 2px 6px rgba(0,0,0,0.05)"
},

filterHeader:{
fontWeight:600,
marginBottom:12,
fontSize:14,
color:COLORS.muted
},

filterRow:{
display:"flex",
flexWrap:"wrap",
gap:16,
alignItems:"flex-end"
},

field:{
display:"flex",
flexDirection:"column",
gap:6
},

label:{
fontSize:12,
color:COLORS.muted
},

input:{
padding:"10px",
border:`1px solid ${COLORS.border}`,
borderRadius:6,
minWidth:150
},

actions:{
display:"flex",
gap:10
},

applyBtn:{
background:COLORS.primary,
color:"#fff",
padding:"10px 18px",
border:"none",
borderRadius:6,
cursor:"pointer"
},

clearBtn:{
background:"#f1f1f1",
padding:"10px 18px",
border:"none",
borderRadius:6,
cursor:"pointer"
},

topControls:{
display:"flex",
flexDirection:"column",
gap:16,
marginBottom:25
},

exportBtn:{
background:"#16A34A",
color:"#fff",
padding:"10px 20px",
border:"none",
borderRadius:8,
cursor:"pointer",
width:"fit-content"
},

btnRow:{
display:"flex",
flexWrap:"wrap",
gap:14
},

btn:{
background:COLORS.primary,
color:"#fff",
padding:"10px 16px",
border:"none",
borderRadius:6,
cursor:"pointer"
},

filters:{
display:"flex",
gap:10,
flexWrap:"wrap",
marginBottom:20
},

select:{
padding:"10px",
border:`1px solid ${COLORS.border}`,
borderRadius:6,
minWidth:180
},

card:{
background:COLORS.card,
borderRadius:12,
border:`1px solid ${COLORS.border}`,
padding:20
},

tableWrap:{ overflowX:"auto" },

table:{
width:"100%",
borderCollapse:"collapse",
minWidth:700
},

th:{
textAlign:"left",
padding:12,
borderBottom:`1px solid ${COLORS.border}`
},

td:{
padding:12,
borderBottom:`1px solid ${COLORS.border}`
}

};

export default Reports;